import { ViewFile } from '@/components/ats';
import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';
import { KText } from '@/ui-library/components/text';
import { Center, Flex } from '@chakra-ui/react';
import { InterviewType } from '../types/interview';

export const InterviewResume = ({
  interview,
}: {
  interview: InterviewType;
}) => {
  const { resume = {} } = interview?.candidate || {};
  const isPreviewAvailable =
    [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/x-ole-storage',
    ]?.includes(resume?.content_type) && resume?.preview?.url;

  if (resume?.content_type !== 'application/pdf' && !isPreviewAvailable)
    return (
      <Center h="100%" flexDir="column" gap="12px">
        <KText fontSize="sm">Resume preview unavailable for this format</KText>
        <ViewFile file={resume} />
      </Center>
    );

  return (
    <Flex w="100%" h="100%" flexDir="column">
      <PDFReaderBrowser
        file={resume?.url}
        content_type={resume?.content_type}
        preview_url={resume?.preview?.url}
        fileName={interview?.candidate?.name}
        showReplaceControl={false}
        styles={{
          container: {
            border: 'none',
          },
        }}
      />
    </Flex>
  );
};
